<div class="skeleton-pulse w-full h-full"></div>
